$(document).ready(function () {
	let badge = '<a class="badge" href="https://www.guidetotennessee.com/united-states/fairview/arts-entertainment/skyline-inflatables-llc?from=badge" title="Find me on Guide to Tennessee" target="_blank"><img src="/theme/Guide to Tennessee badge.png" style="border: none;"/></a>';
	let container = $('.home-video-row__video');

	container.prepend(badge);
});